import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".masonry-flex-wrap {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: stretch;\n}\n.masonry-flex-wrap-column {\n  display: \"flex\";\n  flex-direction: \"column\";\n  justify-content: \"flex-start\";\n  align-content: \"stretch\";\n  flex: 1;\n}";
styleInject(css_248z);

export { css_248z as default };
